import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionBar, ActionBarAriaLabel } from './models/action-bar.interfaces';

@Component({
  selector: 'idp-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent {
  @Input() content: ActionBar = {} as ActionBar;
  @Input() expand = false;

  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggle(): void {
    this.readExpandStatus(
      this.expand ? ActionBarAriaLabel.COLLAPSED : ActionBarAriaLabel.EXPANDED
    );

    this.notify.emit(true);
  }

  readExpandStatus(text: string) {
    const el = document.createElement('div');
    const id = 'speak';
    el.setAttribute('id', id);
    el.setAttribute('aria-live', 'polite');
    el.classList.add('sr-only');
    document.body.appendChild(el);

    setTimeout(() => {
      (document.getElementById(id) as HTMLElement).innerHTML = text;
    }, 100);
    setTimeout(() => {
      document.body.removeChild(document.getElementById(id) as HTMLElement);
    }, 1000);
  }
}
